import { PREVIEW } from 'constants/Parameters';

export const getLocalStorageItem = (key: string): unknown => {
  if (!PREVIEW && 'localStorage' in window) {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : undefined;
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }
  return undefined;
};

export const setLocalStorageItem = (key: string, value: unknown): void => {
  if (!PREVIEW && 'localStorage' in window) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(error);
    }
  }
};

export const removeLocalStorageItem = (key: string): void => {
  if (!PREVIEW && 'localStorage' in window) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(error);
    }
  }
};
